$(document).ready(function () {
  getCartItem();
});
var getSelectedvariant;
var getVariantIds = [];
var selectedImg;

function selectedVariantImage(img) {
  selectedImg = img;
}

/*Get current variant details*/
function selectedVariant(variant) {
  getSelectedvariant = variant;
}

/* Removing Item from cart */
function removeItem(getVariantId, uniqueAssociatedKey) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      if(uniqueAssociatedKey == 'undefined') uniqueAssociatedKey = ''
      for (var i = 0; i < data.items.length; i++) {
        data.items[i].properties["_associated_unique_key"] = data.items[i].properties["_associated_unique_key"] ? data.items[i].properties["_associated_unique_key"] : ''
        if (parseInt(getVariantId) == parseInt(data.items[i]?.properties?._associated_link_variant_id) || (getVariantId == data.items[i].variant_id && uniqueAssociatedKey == data.items[i].properties["_associated_unique_key"]) || getVariantId == data.items[i].properties._sccl_associated_variant_id || (getVariantId == data.items[i].properties._complimentary_associated_variant_id && uniqueAssociatedKey == data.items[i].properties["_associated_unique_key"]) || (getVariantId == data.items[i].properties._stone_associated_variant_id && uniqueAssociatedKey == data.items[i].properties["_associated_unique_key"]) || (getVariantId == data.items[i].properties._associated_variant_id && uniqueAssociatedKey == data.items[i].properties["_associated_unique_key"]) || getVariantId == data.items[i].properties.DiamondId || (getVariantId == data.items[i].properties._engrave_associated_var_id && uniqueAssociatedKey == data.items[i].properties["_associated_unique_key"])) {
          var arr = data.items[i].key;
          getVariantIds.push(arr)
        }
      }
     removeAllVariantsMiniCart(getVariantId, 'normal');
    },
    error: function (e) {
      console.log(e)
    }
  });
}

function removeAllVariantsMiniCart(currentVariantId, p_type) {
  var obj = {};
  $.each(getVariantIds, function (i, v) {
    obj[v] = 0;
  });
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: obj
    },
    dataType: 'json',
    success: function (data) {
      obj = {};
      getVariantIds = [];
      if (p_type == 'normal') {
        $(`#show_remove_text_${currentVariantId}`).removeClass("hide");
      } else {
        console.log('else')
      }
      setTimeout(
        function () {
          getCartItem();
        }, 1500);
    },
    error: function (e) {
      console.log(e)
    }
  });
}

/* Item added preview */
function itemAdded(itemsCount) {
  var appendData = "";
  var engravableTag = currentProductJson.tags.filter(s => s.includes('Engravable'));
  appendData += `<div class="cart__popover--preview-icon">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.5 0C6.94386 0 0 6.94387 0 15.5C0 23.299 5.76595 29.7608 13.2696 30.8423C13.317 30.849 13.3651 30.8462 13.4114 30.8343C13.4577 30.8223 13.5012 30.8013 13.5394 30.7726C13.5775 30.7438 13.6097 30.7078 13.6339 30.6666C13.6582 30.6254 13.6741 30.5799 13.6808 30.5325C13.6874 30.4852 13.6847 30.437 13.6727 30.3907C13.6608 30.3444 13.6398 30.301 13.611 30.2628C13.5823 30.2246 13.5463 30.1925 13.5051 30.1682C13.4639 30.1439 13.4183 30.128 13.371 30.1214C6.21669 29.0902 0.72093 22.9439 0.72093 15.5C0.72093 7.33349 7.33348 0.72093 15.5 0.72093C23.6665 0.72093 30.2791 7.33349 30.2791 15.5C30.2791 23.6666 23.6665 30.2791 15.5 30.2791C15.4104 30.2877 15.3272 30.3294 15.2666 30.396C15.206 30.4627 15.1725 30.5495 15.1725 30.6395C15.1725 30.7296 15.206 30.8164 15.2666 30.8831C15.3272 30.9497 15.4104 30.9914 15.5 31C24.0561 31 31 24.0561 31 15.5C31 6.94387 24.0561 0 15.5 0ZM23.1486 9.72129C23.0545 9.72501 22.9655 9.76545 22.9008 9.83394L13.3372 19.6566L9.00036 15.2071C8.933 15.1391 8.84144 15.1004 8.74569 15.0997C8.64993 15.0989 8.55777 15.136 8.48932 15.203C8.42087 15.27 8.38169 15.3613 8.38036 15.457C8.37903 15.5528 8.41564 15.6452 8.48219 15.714L13.0781 20.4339C13.1117 20.4686 13.152 20.4962 13.1965 20.5151C13.241 20.534 13.2889 20.5437 13.3372 20.5437C13.3856 20.5437 13.4334 20.534 13.4779 20.5151C13.5224 20.4962 13.5627 20.4686 13.5963 20.4339L23.419 10.3408C23.472 10.2898 23.5081 10.2237 23.5224 10.1515C23.5368 10.0793 23.5287 10.0045 23.4993 9.93705C23.4698 9.86959 23.4204 9.81276 23.3578 9.77419C23.2951 9.73562 23.2221 9.71716 23.1486 9.72129Z"
                        fill="#CB9F91" />
                    </svg>
                  </div>
                  <div class="cart__popover--preview-text"> ${itemsCount && itemsCount === 'multiple' ? `Items Added` : `Item Added` } </div>
                    <div class="cart__popover--preview-thumb" id="js-append-image">
                     <img src="${getSelectedvariant.featured_image && currentProductJson.id !== 7016921235544 && currentProductJson.id !== 6644686127192 && (engravableChecked === false || currentProductJson.id === 6571931140184 || currentProductJson.id === 7333859328088 || currentProductJson.id === 8146690572376 || currentProductJson.id === 8146703089752) ? getSelectedvariant.featured_image.src : selectedImg}"
                      alt="">
                  </div>`;
  $('.cart__popover').addClass('adding-to-cart');
  $('.cart__popover--preview').html(appendData);
  $('.cart__popover--preview').attr('aria-live', 'polite').attr('role', 'alert');
  $("#js-cart-visibility").removeClass("hide");
  $("#cart-items").addClass("hide");
  $("#js-blank-cart").addClass("hide");
  $("#js-item-added").removeClass("hide");
  $("#js-order-subtotal").removeClass("hide");
  if (currentProductJson && currentProductJson.id === 7016921235544 && currentProductJson.id === 6644686127192 || currentProductJson.id === 6835070795864 || currentProductJson.id === 6569861677144 || currentProductJson.id === 6571931140184 || currentProductJson.id === 7110824231000) {
    setTimeout(function () {
      $("#cart-items").removeClass("hide");
      $("#js-item-added").addClass("hide");
      $("#js-cart-visibility").addClass("hide");
      $(".switch").removeClass("hide");
      if ($('#engravablesInputsWrapper').is(":checked")) $("#input-text-engraving-styles, #input-text-engraving-styles-optional, #input-text-engraving-styles-optional-three, #engravable_placement_dropdown_input_box, .engravable_drop_down, .engravable_placement_drop_down").removeAttr("disabled");
      $(".HorizontalList__Item").find("input").removeAttr("disabled", "disabled");
      enableAddToCartButton();
    }, 4000);
    if (engravableTag && engravableTag.includes && !engravableTag.includes('Engravable')) {
      enableAddToCartButton();
    }
  } else {
    $("#weddingDateSelector").hide();
    setTimeout(
      function () {
        $("#cart-items").removeClass("hide");
        $("#js-item-added").addClass("hide");
        $("#js-cart-visibility").addClass("hide");
        $(".switch").removeClass("hide");
        if ($('#engravablesInputsWrapper').is(":checked")) $("#input-text-engraving-styles, #input-text-engraving-styles-optional, #input-text-engraving-styles-optional-three, #engravable_placement_dropdown_input_box, .engravable_drop_down, .engravable_placement_drop_down").removeAttr("disabled");
        $(".HorizontalList__Item").find("input").removeAttr("disabled", "disabled");
        enableAddToCartButton();
      }, 4000);
    if (engravableTag && engravableTag.includes && !engravableTag.includes('Engravable')) {
      enableAddToCartButton();
    }
  }
}

/* Append item to cart drawer */
function getCartItem() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
    if (data.items.length <= 1) {
     $('#cart-item-count').text('Cart You have '  + data.items.length + ' item');
    }else{
     $('#cart-item-count').text('Cart You have ' + data.items.length + ' items');
    }
      if (data.items.length != 0) {
        $('.cart__popover--items').html('');
        $('.cart__popover--subtotal-amount').html('');
        var appendData = "";
        var total_price = "";
        var total_price = "";
        var totalSavings = 0;

        // --- Cache product JSON by handle ---
        var productCache = {};
        var requests = [];

        for (var i = 0; i < data.items.length; i++) {
          var dataItems = data.items[i] ? data.items[i] : {}
          if (dataItems.handle != 'emerald-stone-selection' && dataItems.handle != 'pear-stone-selection' && dataItems.handle != 'custom-stone-count' && dataItems.handle != 'custom-stone-count-2' && dataItems.handle != 'custom-stone-count-band' && dataItems.handle != 'complimentary-gift' && dataItems.handle != 'gift-wrap' && dataItems.handle != 'i-dont-know-my-ring-sizer-ghost-product' && dataItems.handle != 'ccl1' && dataItems.handle != 'ccl2' && dataItems.handle != 'ccl3' && dataItems.handle != 'color-dropdown' && dataItems.handle != 'ring-concierge-gift-card' && dataItems.handle != 'soft-chain-custom-length' && dataItems.handle != 'gift-wrapping-1' && dataItems.handle != 'vow-eng-ring-sizer' && dataItems.handle != 'gift-wrapping' && dataItems.handle != 'add-engraving' && dataItems.product_type !== 'Diamond' && dataItems.product_type !== 'Home-Try-On-Kit') {
            var productName = dataItems.product_title;
            var product_variant_title = dataItems.variant_title != null ? dataItems.variant_title : dataItems.product_title;
            var products_total_price = data.total_price;
            var product_url = dataItems.url;
            var productQuantitiy = dataItems.quantity;
            var productImage = dataItems.image;
            var uniqueAssociatedKey = dataItems?.properties["_associated_unique_key"];

            if (dataItems?.product_id == 7016921235544) productImage = dataItems.properties["_toi_moi_image"]
            if (dataItems?.product_id == 6644686127192) productImage = dataItems.properties["_zodiac_image"]
            if (dataItems?.product_id == 7374146306136) productImage = dataItems.properties["_image"]
            if (dataItems?.properties["_engraving_image"] && currentProductJson?.id !== 8005498110040) productImage = dataItems.properties["_engraving_image"]

            if (dataItems.properties?.DiamondId) {
              var product_variant_id = dataItems.properties.DiamondId;
            } else {
              var product_variant_id = dataItems.variant_id;
            }

            var productKey = dataItems.key;
            var productHandle = dataItems.handle;

            appendData += `<li class="cart__popover--item" id=remove_item_${product_variant_id}>
                             <div class="cart__popover--removed hide" id="show_remove_text_${product_variant_id}"><div class="cart__popover--removed-text">${productName} has been removed.</div></div>
                             <div class="cart__popover--thumb">
                               <a href="${product_url}"><img src="${productImage}" alt=""></a>
                             </div>
                             <div class="cart__popover--info">
                               <a href="${product_url}"><h4 class="cart__popover--title">${productName}</h4></a>
                               <a href="${product_url}"><p class="cart__popover--subtitle">${product_variant_title}</p></a>
							   <p class="cart__popover--subtitle">Qty: ${productQuantitiy}</p>
                             </div>
                             <div class="cart__popover--item-removed" onclick=removeItem('${product_variant_id}','${uniqueAssociatedKey}')>
                               <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                               <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M5.89926 7.31434L0.94983 12.2638L2.36404 13.678L7.31348 8.72855L12.2629 13.678L13.6771 12.2638L8.72769 7.31434L13.6778 2.36428L12.2635 0.950062L7.31348 5.90012L2.36341 0.950062L0.949201 2.36428L5.89926 7.31434Z"
                                fill="#B7BCBF" />
                               </svg>
                             </div>
                           </li>`;
            total_price = parseFloat(products_total_price) / 100;
            if (total_price != null && total_price % 1 != 0) total_price = parseFloat(total_price).toLocaleString(undefined, { minimumFractionDigits: 2 });

            // === Collect product JSON request (only once per handle) ===
            if (!productCache[productHandle] && !hideSavingTextCartMiniCart) {
              productCache[productHandle] = $.getJSON(`/products/${productHandle}.js`);
              requests.push(productCache[productHandle]);
            }
          }
        }

        // Wait for all product JSON fetches
        $.when.apply($, requests).done(function () {
          var responses = arguments.length === 3 && arguments[1] === "success" ? [arguments] : arguments;
          for (let i = 0; i < responses.length; i++) {
            let resp = responses[i][0]; 
            productCache[resp.handle] = resp;
          }
          // --- Now calculate savings ---
          data.items.forEach(function (dataItems) {
            if (productCache[dataItems.handle]) {
              var product = productCache[dataItems.handle];
              var variantInfo = product.variants.find(v => parseInt(v.id) === parseInt(dataItems.variant_id));
              if (variantInfo) {
                var compareAt = variantInfo.compare_at_price ? variantInfo.compare_at_price / 100 : 0;
                var unitPrice = dataItems.price / 100; 
                var qty = dataItems.quantity;
                var expected = compareAt > unitPrice ? compareAt * qty : unitPrice * qty;
                var actual = dataItems.final_line_price / 100;
                var itemSavings = expected - actual;
                if (itemSavings > 0) {
                  totalSavings += itemSavings;
                }
              }
            }
            // === Savings row appended right after subtotal ===
            if (totalSavings > 0 && pageType !== 'cart') {
              setTimeout(function () {
                $(".cart__popover--savings").remove(); // prevent duplicates
                var formattedSavings = totalSavings.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                $(".docapp-cart-subtotal").after(
                  `<div class="cart__popover--savings" style="text-align:right;color:red;font-weight:bold">You are saving $${formattedSavings}</div>`
                );
              }, 1000 );
            }
          });
        });
        
        $('.cart__popover--items').html(appendData);
        $('.cart__popover--subtotal-amount').html('$' + total_price);
        $("#js-blank-cart").addClass("hide");
        $("#js-order-subtotal").removeClass("hide");
        $(".Header__CartDot").addClass("is-visible");
      } else {
        $("#cart-items").addClass("hide");
        $("#js-item-added").addClass("hide");
        $("#js-blank-cart").removeClass("hide");
        $(".Header__CartDot").removeClass("is-visible");
        $("#js-order-subtotal").addClass("hide");
      }
      cleanOrphanGhostProducts();
    },
    error: function (e) {
      console.log(e)
    }
  });
}